import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { createPortionLabelSelector } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/Helpers';
import { StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { PageSection } from '../../../../../../Layout';
import SubspecimenDryMassesSection from './SubspecimenDryMassesSection';
import SubspecimenWetMassesSection from './SubspecimenWetMassesSection';

let SubspecimenMassesPageSection: React.FC<IWorksheetComponent> = ({ namePrefix, createWorksheetSelector }) => {
  const isInitiallyDry = useSelector(
    pipe(
      createWorksheetSelector!('Preparation.StateAfterInitialPreparation'),
      (s: StateOfMaterial) => s === StateOfMaterial.OvenDry
    )
  );

  const subspecimenLabel = useSelector(
    createPortionLabelSelector(createWorksheetSelector!, `${namePrefix!}.Subspecimen`)
  );

  return (
    <PageSection heading={`${subspecimenLabel} Mass`}>
      {isInitiallyDry ? <SubspecimenDryMassesSection /> : <SubspecimenWetMassesSection />}
    </PageSection>
  );
};

SubspecimenMassesPageSection = withInjectedProps(SubspecimenMassesPageSection);

export { SubspecimenMassesPageSection };
export default SubspecimenMassesPageSection;
